export default __webpack_public_path__ + "static/media/image.ef8e4321.jpg";